import { AfterViewInit, Component, ViewChild, TemplateRef, ChangeDetectionStrategy} from "@angular/core";
import { ICellRendererAngularComp } from 'ag-grid-angular';
import {IDropdownItem} from '@irb-common/models/dropdown.model';

@Component({ standalone: false,
  selector: "irb-dropdown-search-multiple-cell",
  template: `
      <irb-dropdown-search-multiple
        #dropdownSearchMultiple
        (search)="populateDropdown($event)"
        (selection)="onSelect($event)"
        (applySelection)="onApply($event)"
        (keydown)="$event.stopPropagation()"
        [width]="width"
        [enableHiddenSearchResults]="enableHiddenSearchResults"
        [enableEmptySearchTerm]="enableEmptySearchTerm"
        [cellStyle]="cellStyle"
        [showApplyButton]="showApplyButton" 
        [noOptionsTemplate]="noOptionsTemplate"
        [canEdit]="canEdit"
        [showNone]="showNone"
        [noneDisplayText]="noneDisplayText"
        [placeholder]="placeholder"
        [hiddenLabelPanelTitle]="hiddenLabelPanelTitle"
        [hiddenLabelDescription]="hiddenLabelDescription"
        [showAsAll]="showAsAll"
      ></irb-dropdown-search-multiple>
    `,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DropdownSearchMultipleRendererComponent implements ICellRendererAngularComp, AfterViewInit {
  @ViewChild('dropdownSearchMultiple') dropdownSearchMultiple: any;

  params: any;
  value: Array<IDropdownItem>;
  isNotApplicable: boolean = false;
  enableHiddenSearchResults: boolean = true;
  enableEmptySearchTerm: boolean = false;
  width: number;
  cellStyle: string = "default";
  showApplyButton: boolean = false;
  noOptionsTemplate: TemplateRef<any>;
  canEdit: boolean;
  showNone: boolean;
  noneDisplayText: string;
  placeholder: string;
  hiddenLabelPanelTitle: string;
  hiddenLabelDescription: string;
  showAsAll: boolean = false
  isAllSelected: boolean = true;

  constructor() {}

  agInit(params: any) {
    this.params = params;
    this.value = this.params.defaultValue;
    this.width = this.params.width || 260;
    this.isNotApplicable = (typeof this.params.isNotApplicable !== "undefined") ? this.params.isNotApplicable : false;    
    this.enableHiddenSearchResults = (typeof this.params.enableHiddenSearchResults !== "undefined") ? this.params.enableHiddenSearchResults : true;
    this.enableEmptySearchTerm = (typeof this.params.enableEmptySearchTerm !== "undefined") ? this.params.enableEmptySearchTerm : false;
    this.cellStyle = (typeof this.params.cellStyle !== "undefined") ? this.params.cellStyle : "default";
    this.showApplyButton = (typeof this.params.showApplyButton !== "undefined") ? this.params.showApplyButton : false;
    this.noOptionsTemplate = (typeof this.params.noOptionsTemplate !== "undefined") ? this.params.noOptionsTemplate : null;
    this.canEdit = (typeof this.params.canEdit !== "undefined") ? this.params.canEdit : true;
    this.showNone = (typeof this.params.showNone !== "undefined") ? this.params.showNone : true;
    this.noneDisplayText = (typeof this.params.noneDisplayText !== "undefined") ? this.params.noneDisplayText : "none";
    this.placeholder = (typeof this.params.placeholder !== "undefined") ? this.params.placeholder : '';
    this.hiddenLabelPanelTitle = (typeof this.params.hiddenLabelPanelTitle !== "undefined") ? this.params.hiddenLabelPanelTitle : '';
    this.hiddenLabelDescription = (typeof this.params.hiddenLabelDescription !== "undefined") ? this.params.hiddenLabelDescription : '';
    this.showAsAll = (typeof this.params.showAsAll !== "undefined") ? this.params.showAsAll : false;
    this.isAllSelected = (typeof this.params.isAllSelected !== "undefined") ? this.params.isAllSelected : true;

    if (this.isNotApplicable) {
      this.value = [{
        name: "n/a",
        value: null
      }];
    }
  }

  ngAfterViewInit() {
    if (this.value && !this.isNotApplicable) {
      if (!this.isAllSelected)
        this.dropdownSearchMultiple.isAllSelected = false;
      this.dropdownSearchMultiple.setValue(this.value);
    }
  }

  refresh(): boolean {
    return true;
  }

  populateDropdown(searchString: string): void {
    if (searchString && searchString.length > 0) {
      this.dropdownSearchMultiple.set((this.params.values || [])
        .filter((item: any) => item.name &&
            item.name.toUpperCase().startsWith(searchString.toUpperCase()))
        );
    } else if(this.enableEmptySearchTerm) {
      this.dropdownSearchMultiple.set(this.params.values || []);
    }
  }

  onSelect(selection: Array<IDropdownItem>): void {
    this.value = selection;
    
    if(this.params.onChange) {
      this.params.onChange(this.params, this.value);
    }
  }

  onApply(selection: Array<IDropdownItem>): void {
    this.value = selection;
    
    if(this.params.onApply) {
      this.params.onApply(this.params, this.value);
    }
  }
}
